(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LinkPrevue", [], factory);
	else if(typeof exports === 'object')
		exports["LinkPrevue"] = factory();
	else
		root["LinkPrevue"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition